import type { SpatialRectangle } from "@pdfking/renderer"

import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

export const RectangleFromArray = (
  options: PdfEngineOptions,
  array: number[]
): SpatialRectangle => {
  const [llx, lly, urx, ury] = array.map(a => a / options.unit_to_px)

  return {
    x: llx,
    y: lly,
    width: urx - llx,
    height: ury - lly,
  }
}
